import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { includes } from 'lodash';
import {
  queryCustomerPermissions,
  getStorageItems,
  trackSegmentEvent,
  getCurrentUserInfoSuccess,
  getCurrentUserInfoFailure
} from 'actions';
import { getUser, getErrors, getUserAuthentication } from 'selectors';
import { useDeepCompareEffect, useDebounceEffect } from 'hooks';
import { getRailsUrl } from 'utilities/integration/rails';
import { urlMap, SIGNIN_PAGES } from 'routes/urlMap';
import { useFeatureFlaggingService } from 'hooks/useFeatureFlaggingService';
import WonoloSpinnerLoader from 'components/common/loaders/WonoloSpinnerLoader';
import { getCurrentUserInformation } from 'api/currentUser';
import { Profile } from './components';
import {
  intercomLoader, hasOneOrMoreErrors, getUserBrowser
} from './helpers';
import { fingerprint, meta } from './constants';

export const ProfileContainer = (props) => {
  const user = useSelector(getUser);
  const authenticated = useSelector(getUserAuthentication);
  const userId = user.id;
  const userRole = user.role;
  const history = useHistory();
  const { pathname } = history.location;
  const { email, fullName: name } = user;

  const didFlagsLoad = useFeatureFlaggingService();
  const allErrors = useSelector(getErrors);
  const showError = hasOneOrMoreErrors(allErrors, fingerprint);
  const dispatch = useDispatch();

  // fetch user data
  // if user data cannot be fetched ex. no authentication token
  // user will be redirected to sign in page
  const getUserInformation = () => {
    getCurrentUserInformation().then((userInformationResponse) => {
      dispatch(getCurrentUserInfoSuccess({ ...userInformationResponse, meta }));
    }).catch((error) => {
      getCurrentUserInfoFailure({ error, meta });
      window.open(getRailsUrl(urlMap.RAILS_SIGNIN), '_self');
    });
  };

  useDeepCompareEffect(() => {
    if (!userId && !includes(SIGNIN_PAGES, pathname)) {
      getUserInformation();
    } else {
      intercomLoader({ userId, name, email });
      // get sessionStorageItems
      dispatch(getStorageItems());
      if (userId) {
        dispatch(queryCustomerPermissions({ meta }));
      }
    }
  }, [user]);

  useDebounceEffect(() => {
    const { clientHeight, clientWidth } = document.body;
    const parentHeight = clientHeight + 43;
    const parentWidth = clientWidth + 209;

    dispatch(trackSegmentEvent({
      event: 'click',
      properties: {
        name: 'BROWSER_SIZE',
        browser: getUserBrowser(),
        clientHeight: `${clientHeight}px`,
        clientWidth: `${clientWidth}px`,
        parentHeight: `${parentHeight}px`,
        parentWidth: `${parentWidth}px`,
      },
    }));
  }, [])(500);

  if (authenticated && !didFlagsLoad && !includes(SIGNIN_PAGES, pathname)) {
    return (
      <WonoloSpinnerLoader />
    );
  }

  return <Profile {...props} showError={showError && !includes(SIGNIN_PAGES, pathname)} />;
};

export default ProfileContainer;
